var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('Header'),_c('Sidebar'),_c('div',{staticClass:"comp-box"},[_c('transition',{attrs:{"name":"move","mode":"out-in"}},[_c(_vm.currentComp,{tag:"component",staticClass:"comp"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }